import type { FC } from 'react';
import { OldInput } from '@ui';

interface PickupSearchInputProps {
  className?: string;
  value: string;
  onChange: (value: string) => void;
}

const PickupSearchInput: FC<PickupSearchInputProps> = ({
  className,
  value,
  onChange
}) => (
  <OldInput
    className={className}
    field='search'
    name='search'
    placeholder='Поиск'
    getInputData={({ value: v }: { value: string }) => {
      onChange(v);
    }}
    value={value}
  />
);

export default PickupSearchInput;
